// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".promptModal-modal{border-radius:var(--border-radius);overflow:scroll;max-height:100vh}.promptModal-modal ::-webkit-scrollbar-corner{background:transparent}.promptModal-modal .v--modal-box.v--modal{width:var(--prompt-modal-width)!important;left:unset!important;margin:auto!important}", ""]);
// Exports
module.exports = exports;
